module.exports = __webpack_public_path__ + "img/lens-unavailable.af25670e.svg";